import React, { useState } from 'react';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, horizontalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CusAutocomplete from '../CusAutocomplete';
import SortableChip from './SortableChip';
import FlexContainer from '../adaptive/FlexContainer';

export default function CusAutocompleteDragDrop({ id, options, onChange, values = [], label }) {
  const { t } = useTranslation();
  const [draggingId, setDraggingId] = useState(null);

  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const handleDragEnd = ({ active, over }) => {
    setDraggingId(null);
    if (over && active.id !== over.id) {
      const oldIndex = values.findIndex((v) => v.value === active.id);
      const newIndex = values.findIndex((v) => v.value === over.id);
      onChange(arrayMove(values, oldIndex, newIndex));
    }
  };

  const handleDelete = (delOption) => {
    onChange(values.filter((el) => el.value !== delOption.value));
  };

  return (
    <Box>
      <FlexContainer gap={0.5} mb={1} alignItems={'auto'}>
        {typeof label === 'string' ? <Typography>{t(label)}</Typography> : label}

        {values.length > 0 && (
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragStart={({ active }) => setDraggingId(active.id)}
            onDragEnd={handleDragEnd}>
            <SortableContext
              items={values.map((v) => v.value)}
              strategy={horizontalListSortingStrategy}>
              <Stack
                direction="row"
                gap={0.5}
                flexWrap="wrap"
                sx={{
                  px: 0.75,
                  py: 0.5,
                  minHeight: 28,
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: draggingId ? 'primary.main' : 'divider',
                  bgcolor: draggingId ? 'action.hover' : 'transparent'
                }}>
                {values.map((chip) => (
                  <SortableChip
                    key={chip.value}
                    chip={chip}
                    onDelete={handleDelete}
                    isActive={draggingId === chip.value}
                  />
                ))}
              </Stack>
            </SortableContext>
          </DndContext>
        )}
      </FlexContainer>

      <CusAutocomplete
        multiple
        id={id}
        options={options}
        value={values}
        renderTags={() => <></>}
        onChange={(e, vals) => onChange(vals)}
      />
    </Box>
  );
}
